import { useEffect } from "react";

export const Menu = (url, name) => {
	useEffect(() => {
		const script = document.createElement("script");
		const _appNavigationOptions = {
			menuApplicationId: undefined,
			useMenuItemFallback: false,
			copyBodyStyle: false
		};

		script.src = url;
		script.onload = () => {
			const appNavigation = window[name];
			console.log(appNavigation);
			if (typeof (appNavigation) !== "undefined") { appNavigation.render(_appNavigationOptions); }
		};

		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, [url, name]);
};